import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import { humanize } from "../../utils/format.ts";
import { isJobActive } from "../../utils/status.ts";
import LiveDot, { LIVE_DOT_BOX } from "../LiveDot.tsx";
import StatusIcon from "../StatusIcon.tsx";

const SLOT = 20;

function agentStatusTitle(status: string, agentName?: string | null): string {
  const who = agentName || "The agent";
  return `${who} is ${status === "running" ? "running" : "starting"}`;
}

/**
 * An agent run's status as one icon, the last thing in its row: the live dot
 * while it works, a green check once it completed, red when it failed. What it
 * means is in the tooltip. A fixed-width slot, so a column of runs lines up.
 */
export default function AgentRunStatusIcon({
  status,
  agentName,
  error,
}: {
  status: string;
  agentName?: string | null;
  error?: string | null;
}) {
  let icon;
  if (isJobActive(status)) {
    const title = agentStatusTitle(status, agentName);
    icon = (
      <Tooltip title={title}>
        <Box component="span" role="status" aria-label={title} sx={LIVE_DOT_BOX}>
          <LiveDot />
        </Box>
      </Tooltip>
    );
  } else if (status === "completed") {
    icon = <StatusIcon kind="ok" label="Completed" size={18} />;
  } else if (status === "failed") {
    icon = <StatusIcon kind="error" label={error || "Failed"} size={18} />;
  } else if (status === "partial") {
    icon = <StatusIcon kind="attention" label="Partly completed" size={18} />;
  } else {
    icon = <StatusIcon kind="off" label={humanize(status)} size={18} />;
  }
  return (
    <Box
      component="span"
      sx={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: SLOT, flexShrink: 0 }}
    >
      {icon}
    </Box>
  );
}
